import { EditStore } from "../EditCreate/EditStore";

import { ServiceAccountDraft, ServiceAccount } from "../../../../models/ServiceAccount";
import { prepareServiceAccountDraft } from "../../../utils/draft";

import { names } from "./EditServiceAccountActions";
import { names as editCreateNames } from "../../../actions/EditCreateEntityActions";
import { assertTrue } from "../../../utils/assert/index";
import { EntityType } from "../../../../models/EntityType";
import { Division } from "../../../../models/Division";

export interface EditServiceAccountStoreState
{
    draft: ServiceAccountDraft;
    divisions: Division[];
}

export class EditServiceAccountStore extends EditStore<ServiceAccountDraft, EditServiceAccountStoreState>
{
    constructor() {
        super();
        this.state = this.getDefaultStateFor(null);

        this.register<Division>(names.SET_DIVISION, e => this.draft({ DivisionId: e.payload ? e.payload.id : null }));
        this.register<Division[]>(names.SET_DIVISION_ITEMS, e => this.field({ divisions: e.payload }));
        this.register<string>(names.SET_LOGIN, e => this.setUserName(e.payload));
        this.register<string>(names.SET_PASSWORD, e => this.setPassword(e.payload));
        this.register<string>(names.SET_SERVER_URL, e => this.draft({ ServerUrl: e.payload }));
        this.register<boolean>(names.SET_IMPORT_VEHICLES, e => this.draft({ AutoImport: e.payload }));
        
        this.register(editCreateNames.REJECT_DRAFT, e => {
            if(e.meta === EntityType.ServiceAccount)
                return this.getDefaultStateFor(null);
        });
        this.register<ServiceAccount>(editCreateNames.SET_EDIT_ENTITY, e => {
            if(e.meta === EntityType.ServiceAccount)
                return this.getDefaultStateFor(e.payload);
        }) 
    }

    setUserName = (userName: string): EditServiceAccountStoreState => {
        assertTrue(userName === null || typeof userName === 'string');
        return this.draft({ Username: userName });        
    };

    setPassword = (password: string): EditServiceAccountStoreState => {
        assertTrue(password === null || typeof password === 'string');
        return this.draft({ Password: password });
    };

    private getDefaultStateFor(serviceAccount: ServiceAccount): EditServiceAccountStoreState
    {
        return {
            draft: prepareServiceAccountDraft(serviceAccount),
            divisions: []
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/EditServiceAccountStore.ts